import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

// Where "/" and a fresh login land. Users with no permissions can only use Tasks.
const DefaultRedirect = () => {
  const { user } = useSelector((state) => state.profile);

  if (user.loading || !user.info.id) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Navigate to={user.info.permissions.length > 0 ? "/tickets" : "/tasks"} replace />
  );
};

export default DefaultRedirect;
